module.exports = __webpack_public_path__ + "img/logo.d8732df3.png";